import { render, staticRenderFns } from "./SelectPointer.vue?vue&type=template&id=1fb71c5e"
import script from "./SelectPointer.vue?vue&type=script&lang=js"
export * from "./SelectPointer.vue?vue&type=script&lang=js"
import style0 from "./SelectPointer.vue?vue&type=style&index=0&id=1fb71c5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports